module.exports = __webpack_public_path__ + "static/ffcd86fa20b0de68dfab4121a281ada4dc5abf60792d79e8effc93091dcacd30-8a77cb95002cd1a9b0c31e3eda3a7473.jpeg";